var SCM = SCM || {};



SCM.PubHistory = (function ($) {

    return {
        registerToggle: registerToggle
    };

    function registerToggle() {
        $(document.body).on('click', '.js-history-dropdown-trigger', function (e) {
            e.stopPropagation();
            SCM.Toolbar.closeHypothesis();
            $('.js-history-entries-wrap').toggleClass('expanded');
        });
    }
})(jQuery);